// extracted by mini-css-extract-plugin
module.exports = {"partners":"PartnerMerchants_partners__2MbcE","loader":"PartnerMerchants_loader__2_huX"};